import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMemo } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { companyInvoicesRepository } from '~/repositories/companyInvoicesRepository';
import type { GetInvoicesParams } from '~/repositories/companyInvoicesRepository';

export const [CompanyInvoicesProvider, useCompanyInvoices] = createMagicDoorContext('companyInvoices', () => {
  const [invoices, getInvoices, { refetch: refetchInvoices }] = createTriggerResource(async (params?: GetInvoicesParams) => {
    const pagination = await companyInvoicesRepository.getInvoices(params);
    return {
      items: pagination.items,
      page: pagination.currentPage,
      pageSize: pagination.pageSize,
      totalPages: pagination.totalPages,
      totalCount: pagination.totalCount,
    };
  });
  const [invoice, getInvoice, getInvoiceActions] = createTriggerResource((billId: string) => companyInvoicesRepository.getInvoice(billId));
  const payInvoice = createMutation(companyInvoicesRepository.payInvoice);

  const invoiceTotalAmount = createMemo(() => {
    const currentInvoice = invoice();
    if (!currentInvoice) return 0;
    return currentInvoice.summaries.reduce((acc, curr) => acc + curr.itemTotal, 0);
  });

  const handlePayInvoice = async (billId: string, paymentAccountId?: string, paymentMethodId?: string) => {
    await payInvoice({ billId, paymentAccountId, paymentMethodId });
  };

  return {
    getInvoices,
    refetchInvoices,
    invoice,
    getInvoice,
    getInvoiceActions,
    payInvoice,
    invoiceTotalAmount,
    handlePayInvoice,
    invoices,
  };
});
